import TransitApi from './base'

export default {
  async getClient(params) {
    const result = await TransitApi.getSecureInstance().get(
      '/dashboard/client',
      { params, timeout: 30000 }
    )
    return result.data.data
  },
  async getClientInvoice(id) {
    const result = await TransitApi.getSecureInstance().get(
      `/dashboard/client/invoices/${id}`,
      { timeout: 30000 }
    )
    return result.data.data
  },
  async getClientShipment(id) {
    const result = await TransitApi.getSecureInstance().get(
      `/dashboard/client/shipments/${id}`,
      { timeout: 30000 }
    )
    return result.data.data
  },
  async downloadClientReport(params) {
    const result = await TransitApi.getSecureInstance().get(
      '/dashboard/client/report.pdf',
      {
        params,
        responseType: 'blob',
        timeout: 180000,
      }
    )
    if (
      !result.data ||
      result.data.type !== 'application/pdf' ||
      !result.data.size
    )
      throw new Error('No se recibió un PDF válido')
    return result.data
  },
  async downloadOperationsReport(params) {
    const result = await TransitApi.getSecureInstance().get(
      '/dashboard/operations/report.pdf',
      { params, responseType: 'blob', timeout: 180000 }
    )
    if (
      !result.data ||
      result.data.type !== 'application/pdf' ||
      !result.data.size
    )
      throw new Error('No se recibió un PDF válido')
    return result.data
  },
  async getOperations(params) {
    const result = await TransitApi.getSecureInstance().get(
      '/dashboard/operations',
      { params, timeout: 30000 }
    )
    return result.data.data
  },
  async assignPending(id, responsibleParty) {
    const result = await TransitApi.getSecureInstance().patch(
      `/dashboard/operations/pending/${id}`,
      { responsibleParty }
    )
    return result.data
  },
  async assignDistributor(id, distributorId) {
    const result = await TransitApi.getSecureInstance().patch(
      `/dashboard/operations/shipments/${id}/distributor`,
      { distributorId }
    )
    return result.data
  },
  // TODO: Add search, filters and sort params
  async getPieRegularVariation(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(
        `/dashboard/get-pie-invoices-regular-vs-variations?${queryString}`
      )
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // TODO: Add search, filters and sort params
  async getPieCreateDelivered(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(
        `/dashboard/get-pie-invoices-created-vs-delivered?${queryString}`
      )
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getBarCreateDelivered(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(
        `/dashboard/get-bar-created-vs-delivered?${queryString}`
      )
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getBarInvoices(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/dashboard/get-bar-invoices?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // KPI de duración del trámite (días recepción -> entrega, por tramo).
  async getKpiTramite(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(`/dashboard/kpi-tramite?${queryString}`)
      return result.data
    } catch (error) {
      return error.response
    }
  },

  // Trámites más lentos del periodo, para accionar sobre casos concretos.
  async getKpiTramitesLentos(params) {
    try {
      const Api = TransitApi.getSecureInstance()
      const queryString = TransitApi.getQueryString(params)
      const result = await Api.get(
        `/dashboard/kpi-tramite-lentos?${queryString}`
      )
      return result.data
    } catch (error) {
      return error.response
    }
  },

  async getLogs() {
    try {
      const Api = TransitApi.getSecureInstance()
      const result = await Api.get(`/dashboard/get-logs`)
      return result.data
    } catch (error) {
      return error.response
    }
  },
}
